import api from '@/plugins/axios';

const CACHE_KEY = 'payment_provider_cache';
const CACHE_DURATION = 1000 * 60 * 60; // 1 hour

export const paymentService = {
  /**
   * Get the active payment provider (Stripe, Lemon Squeezy, Iyzico)
   * @returns {Promise<{ provider: 'STRIPE' | 'LEMON_SQUEEZY' | 'IYZICO' }>}
   */
  async getActiveProvider() {
    // Check cache first
    const cached = localStorage.getItem(CACHE_KEY);
    if (cached) {
      const { provider, timestamp } = JSON.parse(cached);
      if (Date.now() - timestamp < CACHE_DURATION) {
        return { provider };
      }
    }

    try {
      const response = await api.get('/symbol-service/api/v1/payments/provider');
      const data = response.data;
      
      // Cache the result
      localStorage.setItem(CACHE_KEY, JSON.stringify({
        provider: data.provider,
        timestamp: Date.now()
      }));

      return data;
    } catch (error) {
      console.error('Failed to fetch payment provider:', error);
      throw error;
    }
  },

  /**
   * Create a checkout session for a subscription
   * @param {string} priceId - 'pro' | 'trader'
   * @returns {Promise<{ checkoutUrl: string, provider: string }>}
   */
  async createCheckoutSession(priceId) {
    try {
      const response = await api.post('/symbol-service/api/v1/payments/create-checkout-session', { priceId });
      return response.data;
    } catch (error) {
      if (error.response?.status === 401) {
        // Handle unauthorized handled by interceptors usually, but we can re-throw
        throw new Error('Unauthorized');
      }
      throw error;
    }
  },

  /**
   * Create a customer portal session for managing subscriptions
   * @returns {Promise<{ portalUrl: string }>}
   */
  async createPortalSession() {
    const response = await api.post('/symbol-service/api/v1/payments/create-portal-session');
    return response.data;
  }
};
